<template>
  <!-- 患者管理画面 -->
  <div id="PDashboardPatientManagementModal">
    <div class="modal-card" style="width: 900px;">
      <header class="modal-card-head">
        <p class="modal-card-title">患者管理</p>
      </header>
      <section class="modal-card-body" style="height: 680px;">
        <div class="top-text">
          <div>
            <span>メイン画面の患者一覧に表示する患者を選択してください。</span>
          </div>
          <div>
            <span>登録件数：{{resultList.length}}件</span>
            <span style="margin-left: 10px;">選択件数：{{checkedRows.length}}件</span>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-top: 20px;">
          <div style="margin-left: 15px;">
            <b-button class="is-primary" style="width: 20px;" :disabled="!selectedRow || isErrorOccerred || latestUpdatingFlag" @click="downDetail(selectedRow)">↓</b-button>
            <b-button class="is-primary" style="width: 20px;" :disabled="!selectedRow || isErrorOccerred || latestUpdatingFlag" @click="upDetail(selectedRow)">↑</b-button>
          </div>
          <div>
            <span v-if="latestUpdatingFlag" style="display: inline-block; font-size: 80%; text-align: left;">
              <div>開始時刻：{{latestUpdateStartAt}}</div>
              <div>更新件数：{{latestUpdateCount}}件/{{resultList.length}}件</div>
            </span>
            <b-button v-if="!latestUpdatingFlag" icon-left="refresh" class="is-primary" style="margin-right: 15px;" :disabled="isErrorOccerred" @click="updatePDashboardInfo()">最新情報に更新</b-button>
            <b-button v-if="latestUpdatingFlag" icon-left="refresh" class="is-primary" style="margin: 0 15px 0 5px;" :disabled="isErrorOccerred" @click="checkUpdateStatus()">更新状況を確認</b-button>
          </div>
        </div>
        <div style="text-align: right; margin-right: 15px; min-height: 24px;">
          <span v-if="latestUpdateEndAt" style="font-size: 80%;">{{latestUpdateEndAt}} 更新</span>
        </div>
        <div style="margin-left: 4px;">
          <fieldset :disabled="latestUpdatingFlag">
            <b-table
              id="pDashboardPatientManagementTable"
              :data="resultList"
              :columns="columns"
              checkable
              :checked-rows.sync="checkedRows"
              :selected.sync="selectedRow"
              :mobile-cards="false"
              narrowed>
              <template slot-scope="props">
                <b-table-column>{{props.row.patientExternalId}}</b-table-column>
                <b-table-column>{{props.row.patientName}}</b-table-column> 
                <b-table-column>{{props.row.deviceSerialNumber}}</b-table-column>
                <b-table-column>
                  <input type="date" v-model="props.row.lastOutputDate" :max="currentDate" @focus="holdLastOutputDate(props.row.lastOutputDate)" @blur="checkLastOutputDate()"/>
                </b-table-column>
              </template>
            </b-table>
          </fieldset>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button :disabled="roleId == role.role_salesOffice || isErrorOccerred || latestUpdatingFlag" class="is-primary" style="margin-left: auto;" @click="update()">OK</b-button>
        <b-button class="is-primary" @click="cancel()">キャンセル</b-button>
      </footer>
    </div>
  </div>
</template>

<script>
const UNEXPECTED_ERROR = "予期しないエラーが発生しました。";
import { role } from "@/components/mock/base/const.js";
import { shiftListDetail } from "@/components/mock/guest/patientdashboard/pDashboardUtil";

export default {
  name: "PDashboardPatientManagementModal",
  data() {
    let userInfo = this.getUserInfo();
    return {
      /** 現在日付（サーバ側システム日付） */
      currentDate: null,
      /** 前回出力日に入力した値 */
      previousLastOutputDate: null,
      /** エラーが発生したかどうか */
      isErrorOccerred: false,
      /** 患者管理明細テーブル */
      resultList: [],
      /** 患者管理明細オリジナルテーブル */
      resultListOriginal: [],
      /** チェック行のリスト */
      checkedRows: [],
      /** 選択行のリスト */
      selectedRow: null,
      /** 「最新情報に更新」実施中フラグ */
      latestUpdatingFlag: false,
      /** 「最新情報に更新」エラーフラグ */
      latestUpdateErrorFlag: false,
      /** 「最新情報に更新」開始時刻 */
      latestUpdateStartAt: null,
      /** 「最新情報に更新」終了時刻 */
      latestUpdateEndAt: null,
      /** 「最新情報に更新」更新件数 */
      latestUpdateCount:null,
      /** 操作ユーザの権限確認 */
      role: role,
      roleId: userInfo.roleId,
      /** 患者管理一覧のカラム(直接指定すると上下入替時に消えてしまうためメソッドを設定) */
      columns: [], 
    };
  },
  async mounted() {
    // 初期表示（患者管理初期表示情報取得）
    this.getPatientManagementInfo();
  },
  methods: {
    // 患者管理情報の取得（初期表示＆更新状況を確認に使用）
    async getPatientManagementInfo() {
      // 患者管理情報取得
      let _this = this;
      await this.apiCall(
        function(client) {
          return client.apis.externalPDashboard.getPatientManagementInfoPOST();
        },
        function(result) {
          if (result && result.status == 200) {
            // ヘッダを設定
            _this.setColumns();
            // 患者管理情報を患者管理明細テーブルにセット
            _this.resultList = result.obj.resultList;
            // 患者管理情報を患者管理明細オリジナルテーブルにセット（更新時の比較に使用）
            _this.resultListOriginal = _this.getCopy(result.obj.resultList);
            // 選択フラグがtrueの患者の患者管理情報をチェック行のリストにセット
            _this.checkedRows = _this.resultList.filter(item => item.selectFlag);
            // 「最新情報に更新」実施中フラグをセット
            _this.latestUpdatingFlag = result.obj.externalUserIncidentalInfo.latestUpdatingFlag;
            // 「最新情報に更新」エラーフラグをセット
            _this.latestUpdateErrorFlag = result.obj.externalUserIncidentalInfo.latestUpdateErrorFlag;
            // 「最新情報に更新」開始時刻をセット
            _this.latestUpdateStartAt = result.obj.externalUserIncidentalInfo.latestUpdateStartAt;
            // 「最新情報に更新」終了時刻をセット
            _this.latestUpdateEndAt = result.obj.externalUserIncidentalInfo.latestUpdateEndAt;
            // 「最新情報に更新」更新件数をセット
            _this.latestUpdateCount = result.obj.externalUserIncidentalInfo.latestUpdateCount;
            // 現在日付（サーバ側システム日付）をセット
            _this.currentDate = result.obj.currentDate;

            // 最新情報に更新中のエラーフラグが立っていたらメッセージを表示
            if (_this.latestUpdateErrorFlag) {
              let message = `前回の最新情報への更新が中断しました。
                              しばらく経ってから再度実施してください。`;
              _this.showErrorMessage(message);
            }
          } else {
            _this.isErrorOccerred = true;
            // エラーメッセージ表示
            _this.showErrorMessage(UNEXPECTED_ERROR);
          }
        },
        function(result) {
          _this.isErrorOccerred = true;
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        }
      );
    },
    // テーブルのヘッダを指定（直接指定すると上下入替時に消えてしまうためメソッドを設定）
    setColumns() {
      let columns = [];
        columns.push({
            "field": "patientExternalId",
            "label": "診察券ID",
            "width": 120
          },{
            "field": "patientName",
            "label": "患者氏名",
            "width": 270
          },{
            "field": "deviceSerialNumber",
            "label": "装置シリアル番号",
            "width": 319
          },{
            "field": "lastOutputDate",
            "label": "前回出力日",
            "width": 130
        });
      this.columns = columns;
    },
    // 前回出力日の入力値を保持
    holdLastOutputDate(lastOutputDate){
      this.previousLastOutputDate = lastOutputDate;
    },
    // 前回出力日の確認
    checkLastOutputDate(){
      // 前回出力日が未来日付だった場合、メッセージを表示して直近の値に戻す
      if(this.currentDate < this.selectedRow.lastOutputDate) {
        const _this = this;
        this.$dialog.alert({
          title: "　",
          message: "前回出力日に未来日は指定できません。",
          onConfirm: () => {
            _this.selectedRow.lastOutputDate = _this.previousLastOutputDate;
          }
        });
      }
    },
    // ↑（上）ボタン押下時の処理
    upDetail() {
      if (this.selectedRow.displayOrder != 1) {
        this.shiftListDetail(true);
      }
    },
    // ↓（下）ボタン押下時の処理
    downDetail() {
      if (this.selectedRow.displayOrder != this.resultList.at(-1).displayOrder) {
        this.shiftListDetail(false);
      }
    },
    // 選択中の患者情報の上下入替処理
    shiftListDetail(isUp) {
      // インポートした共通処理を呼び出す
      let result = shiftListDetail(this.resultList, this.selectedRow.displayOrder, isUp, this.selectedRow);
      // 入れ替え結果をセット
      this.resultList = result.targetList;
      this.selectedRow = result.selectedRow;
      // テーブルのヘッダを再セット
      this.setColumns();
    },
    // OKボタン押下時の処理
    async update() {
      const _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "変更されたデータを更新します。<br/>よろしいでしょうか？",
        cancelText: "キャンセル",
        // OK押下後の処理
        onConfirm: async() => {
          try {
            // 編集済リストを取得
            let patientManagementDetailsEditedList = _this.getEditedList();
            // 患者管理情報更新APIを呼び出し
            await this.apiCall(
              function (client) {
                return client.apis.externalPDashboard.setPatientManagementInfoPOST({
                  body: {
                    patientManagementDetails: patientManagementDetailsEditedList,
                  },
                });
              },
              function (result) {
                if (result && result.status == 200) {
                  _this.showMessage("登録が完了しました。", _this.$parent.close);
                } else {
                  _this.isErrorOccerred = true;
                  // エラーメッセージ表示
                  _this.showErrorMessage(UNEXPECTED_ERROR);
                }
              },
              function (error) {
                _this.isErrorOccerred = true;
                _this.showErrorMessage(error);
              }
            );
          } catch (error){
            _this.isErrorOccerred = true;
            // エラーメッセージ表示
            _this.showErrorMessage(UNEXPECTED_ERROR);
          }
        }
      });
    },
    // 編集済リスト取得
    getEditedList() {
      // 編集済リスト
      let patientManagementDetailsEditedList = [];

      // チェック行のリストからIDを抽出
      let checkedPatientIdList = this.checkedRows.map(record => record.patientId);

      for (let result of this.resultList) {
        // チェックボックスの選択状況をリストの選択フラグに反映
        let isSelected = checkedPatientIdList.includes(result.patientId);
        result.selectFlag = isSelected;
        // 前回出力日が空の場合nullに置換
        if (!result.lastOutputDate) {
          result.lastOutputDate = null
        }
        // 初期表示時にコピーしておいた患者管理明細オリジナルリストと比較
        let resultOriginal = this.resultListOriginal.find(item => result.patientId == item.patientId);
        if (result.selectFlag != resultOriginal.selectFlag ||
            result.displayOrder != resultOriginal.displayOrder ||
            result.lastOutputDate != resultOriginal.lastOutputDate) {
          // 編集されている項目があったら編集済リストに追加
          patientManagementDetailsEditedList.push(result);
        }
      }
      
      return patientManagementDetailsEditedList;
    },
    // キャンセルボタン押下時の処理
    cancel() {
      if(this.latestUpdatingFlag){
        this.$parent.close();
      } else {
        // 編集済リストを取得
        let patientManagementDetailsEditedList = this.getEditedList();

        if (patientManagementDetailsEditedList.length == 0) {
          // 変更がない場合はそのまま閉じる
          this.$parent.close();
        } else {
          this.$dialog.confirm({
            title: "　",
            message: "変更されたデータは更新されません。<br/>よろしいでしょうか？",
            cancelText: "キャンセル",
            onConfirm: () => {
              this.$parent.close();
            }
          });
        }
      }
    },
    // 最新情報に更新ボタン押下時の処理
    async updatePDashboardInfo() {
      const _this = this;
      this.$dialog.confirm({
        title: "　",
        message: `編集中のデータは更新されません。<br/>
                  編集中のデータを更新するには「キャンセル」ボタンを押してこのメッセージを閉じ、下部の「OK」ボタンを押してください。<br/><br/>
                  最新情報への更新には数分かかる場合があります。<br/>
                  最新情報に更新しますか？`,
        confirmText: "OK",
        cancelText: "キャンセル",
        // OK押下後の処理
        onConfirm: async() => {
          // 患者ダッシュボード情報最新化APIを呼び出し
          await this.apiCall(
            function (client) {
              return client.apis.externalPDashboard.updatePDashboardInfoPOST();
            },
            // 更新中の表示内容に切り替え
            function (result) {
              if (result && result.status == 200) {
                // 「最新情報に更新」実施中フラグを立てる
                _this.latestUpdatingFlag = true;
                // 「最新情報に更新」開始時刻をセット
                _this.latestUpdateStartAt = result.data;
                // 「最新情報に更新」終了時刻をクリア
                _this.latestUpdateEndAt = null;
                // 「最新情報に更新」更新件数をクリア
                _this.latestUpdateCount = 0;
              } else {
                _this.isErrorOccerred = true;
                // エラーメッセージ表示
                _this.showErrorMessage(UNEXPECTED_ERROR);
              }
            },
            function (error) {
              _this.isErrorOccerred = true;
              _this.showErrorMessage(error);
            }
          );
        },
      });
    },
    // 更新状況を確認ボタン押下時の処理（初期表示時同様）
    async checkUpdateStatus() {
      this.getPatientManagementInfo();
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-card-body {
	padding: 5px;
}
.top-text{
  display: flex;
  justify-content: space-between;
  margin-left: 15px;
  margin-right: 15px;
}
#pDashboardPatientManagementTable {
  position: relative;
}
#pDashboardPatientManagementTable::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: white;
}
</style>
<style lang="scss">
#pDashboardPatientManagementTable .table-wrapper thead tr:nth-child(1) th {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 1px;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/PDashboardPatientManagementModal.vue